import ShortDescription from './ShortDescription';
export default ShortDescription;